module.exports = __webpack_public_path__ + "static/media/close.229108bd.svg";